<template>
  <v-btn
    color="primary"
    bottom
    fixed
    right
    fab
  >
    <slot name="button-float-icon" />
  </v-btn>
</template>

<script>
export default {
  props: {
    icon: {
      type: String,
      default: 'add'
    }
  }
}
</script>
